import type { UploadFile } from './upload';

/** Opens a hidden <input type="file"> and resolves with the chosen file (null on cancel). */
function chooseFile(accept: string, capture?: 'user' | 'environment'): Promise<UploadFile | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    if (capture) input.setAttribute('capture', capture);
    input.style.display = 'none';
    let done = false;
    const finish = (f: UploadFile | null) => {
      if (done) return;
      done = true;
      input.remove();
      resolve(f);
    };
    input.addEventListener('change', () => {
      const file = input.files?.[0];
      finish(file ? { uri: URL.createObjectURL(file), name: file.name, type: file.type || 'application/octet-stream', size: file.size, file } : null);
    });
    input.addEventListener('cancel', () => finish(null));
    document.body.appendChild(input);
    input.click();
  });
}

/** Mobile browsers open the front camera; desktop browsers show a file dialog. */
export const takeSelfie = () => chooseFile('image/*', 'user');
export const pickImage = () => chooseFile('image/*');
export const pickDocument = () => chooseFile('.pdf,image/*');

export const DOCUMENT_HINT = 'PDF, JPG or PNG up to 5 MB';
